import type { CampaignManagementApi } from './campaign-management-api.types';

export interface CreateCampaignResult {
  data: CampaignManagementApi.CreateCampaignData;
  status: 202 | 207;
}

export class CreateCampaignRejectedError extends Error {
  readonly accepted: CampaignManagementApi.CreateCampaignTarget[];

  readonly rejected: CampaignManagementApi.CreateCampaignRejectedTarget[];

  constructor(
    message: string,
    payload: CampaignManagementApi.CreateCampaignValidationData,
  ) {
    super(message);
    this.name = 'CreateCampaignRejectedError';
    this.accepted = payload.accepted;
    this.rejected = payload.rejected;
  }
}
